// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LaiK","rootMobile":"styles_rootMobile__2YGOt"};